import { Toaster } from "react-hot-toast";
import { useSelector } from "react-redux";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "./App.css";
import Login from "./components/LoginPopup";
import ProtectedAdminRoute from "./components/Route/ProtectedAdminRoute";
import ProtectedRoute from "./components/Route/ProtectedRoute";
import { useRestoreSession } from "./hooks/useRestoreSession";
import About from "./pages/About";
import Admin from "./pages/Admin";
import Class from "./pages/Class";
import ClassDetail from "./pages/ClassDetail";
import ConnectGoogleSuccess from "./pages/ConnectGoogleSuccess";
import Course from "./pages/Course";
import Document from "./pages/Document";
import ForgotPassword from "./pages/ForgotPassword";
import Home from "./pages/Home";
import LaptopRental from "./pages/LaptopRental";
import Lession from "./pages/Lession";
import ListStudentRegister from "./pages/ListStudentRegister";
import OtherServices from "./pages/OtherServices";
import Profile from "./pages/Profile";
import Register from "./pages/Register";
import ResetPasswordConfirm from "./pages/ResetPasswordConfirm";
import RegisterStaff from "./pages/Staff/RegisterStaff";
import Success from "./pages/Success";
import { RootState } from "./store";

function App() {
  const showLogin = useSelector((state: RootState) => state.ui.showLogin);
  useRestoreSession();
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/register" element={<Register />} />
        <Route path="/document" element={<ProtectedRoute><Document /></ProtectedRoute>} />
        <Route path="/lession" element={<ProtectedRoute><Lession /></ProtectedRoute>} />
        <Route path="/course" element={<Course />} />
        <Route path="/connect-google-success" element={<ConnectGoogleSuccess />} />
        <Route path="/success" element={<Success />} />
        <Route path="/staff/register" element={<RegisterStaff />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password-confirm" element={<ResetPasswordConfirm />} />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/class"
          element={
            <ProtectedRoute>
              <Class />
            </ProtectedRoute>
          }
        />
        <Route
          path="/list-student-register"
          element={
            <ProtectedRoute>
              <ListStudentRegister />
            </ProtectedRoute>
          }
        />
        <Route
          path="/other-services"
          element={
              <OtherServices />
          }
        />
        <Route
          path="/other-services/laptop-rental"
          element={
              <LaptopRental/>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedAdminRoute>
              <Admin />
            </ProtectedAdminRoute>
          }
        />
        <Route
          path="/class/:id"
          element={
            <ProtectedRoute>
              <ClassDetail />
            </ProtectedRoute>
          }
        />
      </Routes>
      {/* Toast Notification */}
      <Toaster position="top-right" reverseOrder={false} />
      {/* Hiển thị modal Login khi state là true */}
      {showLogin && <Login />}
    </Router>
  );
}

export default App;
